export const SENT = 'SENT';
export const FAILED = 'FAILED';
export const READ = 'READ';
export const QUARANTINED = 'QUARANTINED';
export const PUBLISHED = 'PUBLISHED';
export const SENDING = 'SENDING';